// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"98":"ErrorPage","888":"Auth"}[chunkId] || chunkId) + "." + {"98":"2180afb1","525":"497697d9","888":"dec5bd16"}[chunkId] + ".chunk.css";
};